import { urlServices } from "./param-url.constants";

export const urlServiceProducerKafka = {

    catDiagnosticMasterMassive : {
        upload: urlServices.urlServiceProducerKafka.concat('diagnostic-master-catalog-masive/branchOffice/{branchOfficeId}'),
        download: urlServices.urlServiceProducerKafka.concat('diagnostic-master-catalog-masive/download_diagnostic_template'),
        status: urlServices.urlServiceProducerKafka.concat('diagnostic-master-catalog-masive/status')
    },

    catMedicinesMassive : {        
        upload: urlServices.urlServiceProducerKafka.concat('medicine-masive/branchOffice/{branchOfficeId}'),
        download: urlServices.urlServiceProducerKafka.concat('medicine-masive/download_template'),
        status: urlServices.urlServiceProducerKafka.concat('medicine-masive/status')
    },

    catProcedures : {
        allProcedures: urlServices.urlServiceHospitalResources.concat('procedures/{branchOfficeId}'),
        proceduresByFilters: urlServices.urlServiceHospitalResources.concat('procedures/find-by-filters'),
        saveFile: urlServices.urlServiceProducerKafka.concat('procedures/save-procedures-file/{userId}/{branchOfficeId}'),
        saveProcedure: urlServices.urlServiceHospitalResources.concat('procedures/save-procedures'),
        updateProcedure: urlServices.urlServiceHospitalResources.concat('procedures/update-procedures'),
        deleteProcedure: urlServices.urlServiceHospitalResources.concat('procedures/delete-procedures/{procedureId}'),
        downloadProcedureErrors: urlServices.urlServiceProducerKafka.concat('procedures/download-procedures-errors/{uploadProcessId}'),
        downloadTemplateProcedure: urlServices.urlServiceProducerKafka.concat('procedures/download-template-procedures'),
        statusUploadProcess: urlServices.urlServiceHospitalResources.concat('procedures/status-upload-process/{uploadProcessId}'),
        catalogSexType: urlServices.urlServiceHospitalResources.concat('procedures/catalogs/sex-types'),
        catalogClueAge: urlServices.urlServiceHospitalResources.concat('procedures/catalogs/clue-age'),
        catalogProcedureType: urlServices.urlServiceHospitalResources.concat('procedures/catalogs/procedure-types'),
        catalogProcedureUpdate: urlServices.urlServiceHospitalResources.concat('procedures/catalogs/procedures-update')
    }
}
